import styled from 'styled-components';

const AppContainer = styled.div`
	text-align: center;
	min-width: 100%;
	min-height: 100%;
`;

export default AppContainer;
